/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BatteryLookupTableID } from './BatteryLookupTableID';
import type { Blob } from './Blob';
import type { DriveCycleS3 } from './DriveCycleS3';
import type { InverterLossMapID } from './InverterLossMapID';
import type { MotorLabID } from './MotorLabID';
import type { MotorLossMapID } from './MotorLossMapID';
import type { MotorTorqueCurvesID } from './MotorTorqueCurvesID';
import type { TransmissionLossMapID } from './TransmissionLossMapID';
/**
 * Item with blobs.
 *
 * Used in the library to detect whether this is item that has associated S3 blobs.
 */
export type ItemAndBlobs = {
    item_type?: ItemAndBlobs.item_type;
    component: ((MotorLossMapID | MotorLabID | MotorTorqueCurvesID | BatteryLookupTableID | TransmissionLossMapID | InverterLossMapID) | DriveCycleS3);
    blobs: Array<Blob>;
};
export namespace ItemAndBlobs {
    export enum item_type {
        ITEM_AND_BLOBS = 'item_and_blobs',
    }
}

